<template>
  <!-- ===== HEADER ======================================================== -->

  <!-- Dismiss button -->
  <q-toolbar class="bg-black text-white fixed z-top">
    <q-space />
    <z-btn
      flat
      :icon="icons.menu"
      class="q-pr-xs"
      @click="emit('toggleMenu')"
    />
  </q-toolbar>

  <!-- ===== NAVIGATION ==================================================== -->

  <div class="q-pa-sm" style="padding-top: 50px;">
    <q-list>
      <q-item
        v-for="(item, i) in navigationData()"
        :key="i"
        :to="item.to"
        :active="false"
      >
        <q-item-section side>
          <q-icon size="sm" :name="item.icon" />
        </q-item-section>
        <q-item-section class="text-uppercase">
          <q-item-label>{{ item.label }}</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
    <q-separator spaced />

    <!-- ===== SETTINGS ==================================================== -->

    <q-list dense>
      <q-list>
        <!-- Language Switcher -->
        <q-item clickable @click="switchLanguage()">
          <q-item-section side>
            <q-icon size="sm" :name="icons.language" />
          </q-item-section>
          <q-item-section class="text-uppercase">
            <q-item-label>{{ nextLanguage }}</q-item-label>
          </q-item-section>
        </q-item>

        <!-- Dark Mode Switcher -->
        <q-item clickable @click="dark.toggle()">
          <q-item-section side>
            <q-icon size="sm" :name="dark.isActive ? icons.dark.off : icons.dark.on" />
          </q-item-section>
          <q-item-section class="text-uppercase">
            <q-item-label>{{ modeLabel }}</q-item-label>
          </q-item-section>
        </q-item>

        <!-- Logout -->
        <q-item clickable @click="emit('requestLogout')">
          <q-item-section side>
            <q-icon size="sm" :name="icons.logout" />
          </q-item-section>
          <q-item-section class="text-uppercase">
            <q-item-label>{{ $t({ en: 'Logout', de: 'Logout' }) }}</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-list>
  </div>
</template>

<script setup lang="ts">
import { useTranslator } from '@juit/vue-i18n'
import { useQuasar } from 'quasar'
import { computed } from 'vue'

import { icons } from '@/assets/icons'
import { navigationData } from '@/init/router'

const translator = useTranslator()
const { dark } = useQuasar()

/* ===== EMITS ============================================================== */

const emit = defineEmits<{
  (emit: 'toggleMenu'): void
  (emit: 'requestLogout'): void
}>()

/* ===== STATE ============================================================== */

const nextLanguage = computed(() => {
  if (translator.language === 'de') {
    return new Intl.DisplayNames('en-GB', { type: 'language' }).of('en')
  } else {
    return new Intl.DisplayNames('de-DE', { type: 'language' }).of('de')
  }
})

const modeLabel = computed(() => dark.isActive ?
  translator.t({ en: 'Light mode', de: 'Lichtmodus' }) :
  translator.t({ en: 'Dark mode', de: 'Dunkelmodus' }))

/* ===== ACTIONS ============================================================ */

function switchLanguage(): void {
  if (translator.language === 'de') {
    translator.locale = new Intl.Locale('en-GB')
  } else {
    translator.locale = new Intl.Locale('de-DE')
  }
}
</script>
